import { CONSTANTS, GRAPH_TYPES } from "../../../../constants/app-constant";
import { getLineGraphFormat } from "../../../Dashboard/data_formatter/format-utils";
const { AREA, GENDER } = GRAPH_TYPES;

export const formatDataByTonalitySocial = (
  d = [],
  isLineGraph,
  selectedInlineGraphType
) => {
  try {
    const graph_data = d.graph_data || [];
    const tonalities = CONSTANTS.TONALITY.map((e) => e.value);
    const color = CONSTANTS.TONALITY.map((e) => e.color);
    const listOfEntities = graph_data.map((gd) => gd.topic_name);
    const labels = isLineGraph
      ? getLineGraphFormat(listOfEntities, true)
      : listOfEntities;
    if (selectedInlineGraphType === GENDER) {
      return {
        mValue: 40,
        fValue: 60,
      };
    }
    const datasets = tonalities.map((tonality, index) => {
      const tempArr = graph_data.map((topic) => {
        const topicPost = topic.post_count.filter(
          (pc) => pc.tonality === tonality
        )[0];
        return topicPost ? topicPost.count : 0;
      });
      const tempColor = color[index];
      const toneColor =
        selectedInlineGraphType === AREA && typeof window.Color === "function"
          ? window.Color(tempColor).alpha(0.5).rgbString()
          : tempColor;

      return {
        data: isLineGraph ? getLineGraphFormat(tempArr) : tempArr,
        label: tonalities[index],
        backgroundColor: toneColor,
        borderColor: toneColor,
        fill: selectedInlineGraphType === AREA ? "start" : false,
        lineTension: 0,
      };
    });
    return {
      datasets,
      labels,
    };
  } catch (e) {
    return {
      datasets: [],
      labels: [],
    };
  }
};
